<template>
  <div
    class="notification" 
    v-bind:class="{
      'success': type === 'success',
      'warning': type === 'warning',
      'error': type === 'error',
      'info': type === 'info',
      'light': type === 'light'
    }"
  >
    <div v-if="icon" class="icon">
      <fa-icon 
        :icon="icon" 
        size="1x"
        :spin="icon[1] === 'spinner'"
      />
    </div>
    <div class="label" v-html="message"></div>
  </div>
</template>

<script>
export default {
  name: 'Notification',
  props: [
    'type',
    'message',
    'icon'
  ]
}
</script>

<style scoped lang="scss">
.notification {
  position: relative;
  padding: 8px 10px;
  display: table;
  width: 100%;
  border-radius: 4px;
  box-sizing: border-box;

  > * {
    display: table-cell;
    vertical-align: middle;
  }

  .icon {
    opacity: 0.5;
    width: 1px;
    padding: 0 10px 0 0;
  }

  .label {
    font-size: 14.4px;
  }

  &.info {
    background: rgba(0,0,0,0.03);
  }

  &.light {
    background: rgba(255,255,255,0.75);
  }

  &.success {
    background: rgba(43, 189, 126, 0.7);
    color: #fff;
  }

  &.error {
    background: #ee424d;
    color: #fff;
  }
}
</style>
